'use client'
import {
  convertPointsToCurrency
} from "./chunk-WETELLTX.mjs";
import {
  PaymentConfig
} from "./chunk-UGUU5QSU.mjs";
import {
  context_default,
  defaultState
} from "./chunk-BEC3XFLK.mjs";
import {
  context_default as context_default2
} from "./chunk-IUOD6H5D.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/context/root/provider.tsx
import { useState as useState2 } from "react";

// src/context/redeem/provider.tsx
import { useMemo, useState } from "react";
import { useGetWalletHistory } from "@wbk/api/hooks";
import { useRouter } from "@wbk/config";
import { jsx } from "react/jsx-runtime";
var RedeemProvider = ({ children }) => {
  const { locale } = useRouter();
  const [data, setData] = useState(defaultState);
  const { data: walletData, isLoading } = useGetWalletHistory({ lang: locale });
  const setCoupon = (data2) => {
    setData((prev) => __spreadProps(__spreadValues({}, prev), { coupon: data2 }));
  };
  const setRedeemType = (type) => {
    setData((prev) => __spreadProps(__spreadValues({}, prev), {
      redeem_type: type,
      coupon: defaultState.coupon,
      qitaf: defaultState.qitaf,
      saudi_redeem: !prev.saudi_redeem ? defaultState.saudi_redeem : __spreadProps(__spreadValues({}, prev.saudi_redeem), {
        quantity: 0
      }),
      enable_wallet_credits: type === "wallet"
    }));
  };
  const setSaudiRedeem = (data2) => {
    setData((prev) => __spreadProps(__spreadValues({}, prev), {
      saudi_redeem: data2
    }));
  };
  const setSelectedTicketIds = (data2) => {
    setData((prev) => __spreadProps(__spreadValues({}, prev), {
      selected_ticket_ids: data2
    }));
  };
  const setQitaf = (data2) => {
    setData((prev) => __spreadProps(__spreadValues({}, prev), {
      qitaf: data2
    }));
  };
  const saudiRedeemTotal = useMemo(() => {
    if (!data.saudi_redeem) {
      return 0;
    }
    return convertPointsToCurrency(
      data.saudi_redeem.quantity,
      data.saudi_redeem.productConversion,
      walletData == null ? void 0 : walletData.currency
    );
  }, [data.saudi_redeem, walletData == null ? void 0 : walletData.currency]);
  return /* @__PURE__ */ jsx(
    context_default.Provider,
    {
      value: __spreadProps(__spreadValues({}, data), {
        walletData: {
          currency: (walletData == null ? void 0 : walletData.currency) || "",
          total_balance: (walletData == null ? void 0 : walletData.total_balance) || 0,
          loading: isLoading
        },
        saudi_redeem_total: saudiRedeemTotal,
        setCoupon,
        setRedeemType,
        setSaudiRedeem,
        setSelectedTicketIds,
        setQitaf
      }),
      children
    }
  );
};
var provider_default = RedeemProvider;

// src/context/root/provider.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var WbkPaymentProvider = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  var _a2, _b2, _c, _d, _e;
  const canUseApplePay = props.isApplePayEnabled && !props.isSeason && typeof window !== "undefined" && typeof window.ApplePaySession !== "undefined" && ApplePaySession.canMakePayments();
  const inlinePaytabs = ((_a2 = props.inlinePaytabs) != null ? _a2 : true) && !!((_b2 = PaymentConfig.config) == null ? void 0 : _b2.paytabsClientKey);
  const [state, setState] = useState2(__spreadProps(__spreadValues({}, props), {
    paymentMethod: props.currency === "BHD" ? void 0 : canUseApplePay ? "apple_pay" : inlinePaytabs ? "managed_form" : "credit_card"
  }));
  const setPaymentMethod = (paymentMethod) => {
    setState((prev) => __spreadProps(__spreadValues({}, prev), { paymentMethod }));
  };
  const setCardType = (cardType) => {
    setState((prev) => __spreadProps(__spreadValues({}, prev), { cardType }));
  };
  const setSubscriptionCreditsEnabled = (enabled) => {
    setState((prev) => __spreadProps(__spreadValues({}, prev), { isSubscriptionCreditsEnabled: enabled }));
  };
  const badCheck = props.currency === "BHD" && state.paymentMethod === "credit_card";
  const bhdValid = badCheck ? !!state.cardType : true;
  const isValid = !!state.paymentMethod && bhdValid;
  return /* @__PURE__ */ jsx2(
    context_default2.Provider,
    {
      value: __spreadProps(__spreadValues({}, state), {
        isValid,
        inlinePaytabs,
        isCouponEnabled: (_c = props.isCouponEnabled) != null ? _c : true,
        isApplePayEnabled: (_d = props.isApplePayEnabled) != null ? _d : true,
        isWalletEnabled: (_e = props.isWalletEnabled) != null ? _e : true,
        canUseApplePay,
        setPaymentMethod,
        setSubscriptionCreditsEnabled,
        setCardType
      }),
      children: /* @__PURE__ */ jsx2(provider_default, { children })
    }
  );
};

export {
  WbkPaymentProvider
};
//# sourceMappingURL=chunk-R6CCVCOY.mjs.map